<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="800"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="删模组退库"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="simiot-compact-form"
          :form="form"
          @submit="handleSubmit"
        >
          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 24 }">
              <common-module-input
                mode="imei"
                :rows="15"
                v-decorator="['modules', {
                  initialValue: { data: moduleData },
                  rules: [{ validator: checkModules }],
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', {
                  rules: [
                    { max: 200, message: '最多200个字符' },
                  ]
                }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import CommonModuleInput from '@/components/ModuleInput/Common'
import { deleteModulesToInventory } from '@/api/batch_operation'

export default {
  name: 'BatchOperationDeleteModulesToInventory',
  components: { CommonModuleInput },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    imeis: {
      type: Array,
      default() {
        return []
      }
    },
    moduleSupplierId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'delete_modules_to_inventory' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    moduleData() {
      return (this.imeis || []).map((imei) => ({ imei }))
    }
  },
  methods: {
    checkModules(rule, value, callback) {
      if (!value || !value.inputValue) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入模组IMEI')
        return
      }

      if (value.validateStatus === 'error') {
        callback(value.errorMsg)
        return
      }

      // eslint-disable-next-line standard/no-callback-literal
      callback()
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          const imeis = (values.modules.data || []).map((item) => item.imei).filter((imei) => imei)
          if (imeis.length === 0) {
            this.$warning({ title: '请输入有效 IMEI' })
            return
          }

          this.submitting = true
          deleteModulesToInventory({
            imeis,
            module_supplier_id: this.moduleSupplierId,
            remark: values.remark
          }).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
              this.$success({
                title: '提交成功',
                content: (
                  <div>
                    <p>操作成功，具体操作结果请至 【系统查询】-【批量操作查询】 查看</p>
                  </div>
                )
              })
            }
            this.submitting = false
          }).catch(() => {
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
